package com.pincer.core.rules

import com.pincer.core.model.tree.Candidate

abstract class CompoundRule(val rules: Set<Rule>): Rule() {
    fun scoreEach(candidate: Candidate): List<Float> {
        val scores = mutableListOf<Float>()
        for (rule in rules) {
            scores.add(rule.score(candidate))
        }
        scores.sort()
        return scores
    }
}
